/**
 * userService.ts
 *
 * Service for user-related API calls such as fetching user details and embed info.
 */
import { AxiosResponse } from "axios";
import { api, apiUrls } from "../api";
import { ApiResponse, CustomAxiosRequestConfig } from "../api/api";
const BASE_URL_INFO = "https://bijlee-customer-service-prodhps-fzhhejd5e8a3b0bx.centralindia-01.azurewebsites.net/api/v1";

/**
 * userService
 * Provides methods for user-related API calls.
 */
export const userService = {

  /**
   * getembedinfo
   * Fetches embed info for the user.
   */
  getembedinfo: async (): Promise<any> => {
    try {
      const config: CustomAxiosRequestConfig = {
        headers: {
          "Content-Type": "application/json",
        },
        decrypt: false, // ✅ now allowed
      };

      const response: AxiosResponse = await api.get(
        `${BASE_URL_INFO}/getembedinfo`,
        config
      );
      // ...existing code...
      return response;
    } catch (error: any) {
       throw error
    }
  },
};
